/**
 * Аккордеон прайс-листа: строка услуги раскрывается в описание с кнопкой записи.
 * Состояние живёт на самой разметке - aria-expanded у кнопки и hidden у панели,
 * поэтому без скрипта прайс остаётся читаемым (см. noscript в секции).
 */

const TOGGLE_SELECTOR = '[data-price-toggle]';
const EXPANDED_ATTRIBUTE = 'aria-expanded';
const BLOCK_SELECT_EVENT = 'shopify:block:select';

class PriceAccordion extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.addEventListener('click', this.handleClick);
    document.addEventListener(BLOCK_SELECT_EVENT, this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener(BLOCK_SELECT_EVENT, this.handleBlockSelect);
  }

  handleClick(event) {
    const toggle = event.target.closest(TOGGLE_SELECTOR);

    if (!toggle || !this.contains(toggle)) return;

    this.setExpanded(toggle, toggle.getAttribute(EXPANDED_ATTRIBUTE) !== 'true');
  }

  /** В theme editor выбранная строка раскрывается, чтобы её содержимое было видно сразу. */
  handleBlockSelect(event) {
    if (!this.contains(event.target)) return;

    const toggle = event.target.querySelector(TOGGLE_SELECTOR);

    if (!toggle) return;

    this.setExpanded(toggle, true);
  }

  /**
   * @param {HTMLElement} toggle кнопка строки
   * @param {boolean} expanded раскрыть или свернуть
   */
  setExpanded(toggle, expanded) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!panel) {
      console.warn('price-accordion: у кнопки нет панели из aria-controls', toggle);
      return;
    }

    toggle.setAttribute(EXPANDED_ATTRIBUTE, String(expanded));
    panel.hidden = !expanded;
  }
}

if (!customElements.get('price-accordion')) {
  customElements.define('price-accordion', PriceAccordion);
}
